import { getLuminance } from '@mui/material/styles';
import styleVariables from 'src/scss/_variables.scss';
import {
  BLUE_LUMINANCE_WEIGHT,
  GREEN_LUMINANCE_WEIGHT,
  HEX_COLOR_REGEX,
  LIGHT_COLOR_LUMINANCE_THRESHOLD,
  RGB_COLOR_REGEX,
  RED_LUMINANCE_WEIGHT,
} from 'src/constants/color';

const parseToRgb = (color?: string): [number, number, number] | null => {
  if (!color) {
    return null;
  }

  const hexMatch = color.match(HEX_COLOR_REGEX);

  if (hexMatch) {
    let hex = hexMatch[0].replace('#', '');

    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((c) => `${c}${c}`)
        .join('');
    }

    const intValue = parseInt(hex, 16);

    return [(intValue >> 16) & 255, (intValue >> 8) & 255, intValue & 255];
  }

  const rgbMatch = color.match(RGB_COLOR_REGEX);

  if (rgbMatch) {
    return [
      parseInt(rgbMatch[1], 10),
      parseInt(rgbMatch[2], 10),
      parseInt(rgbMatch[3], 10),
    ];
  }

  return null;
};

export const getTextColorForBackground = (backgroundColor?: string): string => {
  if (!backgroundColor) {
    return styleVariables.colorWhite;
  }

  const rgb = parseToRgb(backgroundColor);

  if (rgb) {
    const [red, green, blue] = rgb;
    const brightness =
      (red * RED_LUMINANCE_WEIGHT +
        green * GREEN_LUMINANCE_WEIGHT +
        blue * BLUE_LUMINANCE_WEIGHT) /
      255;

    return brightness > LIGHT_COLOR_LUMINANCE_THRESHOLD
      ? styleVariables.colorBlack
      : styleVariables.colorWhite;
  }

  try {
    const luminance = getLuminance(backgroundColor);

    return luminance > LIGHT_COLOR_LUMINANCE_THRESHOLD
      ? styleVariables.colorBlack
      : styleVariables.colorWhite;
  } catch {
    return styleVariables.colorWhite;
  }
};

export const toUpperCaseColor = (color?: string): string | undefined => {
  if (!color) {
    return color;
  }

  return color.toUpperCase();
};
